import React, { useState } from 'react';
import { AbacMain } from './Abac';
import PopupTransition from '@/components/ui/PopupTransition';
import { Button } from '@/lib/components/ui/button';

const Testpage = () => {
  const [isAbacOpen, setIsAbacOpen] = useState(false);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-indigo-50 via-white to-cyan-50">
      <div className="text-center">
        <div className="mb-8">
          <h1 className="bg-gradient-to-r from-gray-900 to-gray-600 bg-clip-text text-4xl font-bold text-transparent">
            Test Page
          </h1>
          <p className="mt-2 text-gray-500">Explore the ABAC Permissions Management System</p>
        </div>
        <Button
          onClick={() => setIsAbacOpen(true)}
          className="transform bg-gradient-to-r from-blue-600 to-blue-700 px-8 py-4 text-lg shadow-lg transition-all duration-200 hover:scale-105 hover:from-blue-700 hover:to-blue-800 hover:shadow-xl"
        >
          Open ABAC Permissions Manager
        </Button>

        <PopupTransition open={isAbacOpen} setOpen={setIsAbacOpen}>
          <AbacMain />
        </PopupTransition>
      </div>
    </div>
  );
};

export default Testpage;
